import { Injectable } from "@angular/core";
import { AuthService } from "../repositories/auth.service";
import { UserGroupeService } from "../repositories/user-groupe.service";
import { UserOrganismeService } from "../repositories/user-organisme.service";
import { Router } from "@angular/router";
import { firstValueFrom, Observable, take } from "rxjs";
import { NotificationService } from "../repositories/notification.service";
import { UserService } from "../repositories/user.service";

interface Groupe {
  id: number;
  nom: string;
}

interface Organisme {
  id: number;
  nom: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(
    private authService: AuthService,
    private userGroupeService: UserGroupeService,
    private userOrganismeService: UserOrganismeService,
    private router: Router,
    private notificationService: NotificationService,
    private userService: UserService
  ) {}

  async handleInitialNavigation() {
    const loggedIn = await this.authService.checkUserLogged().pipe(take(1)).toPromise();
    
    const currentUrl = this.router.url;
    const currentPath = currentUrl.split('?')[0];
    console.log(currentUrl)
    if (!loggedIn && currentUrl && currentPath !== '/' && currentPath !== '/login' && currentPath !== '/register' && currentPath !== '/plan-de-salle') {
      this.router.navigate(['login']);
      return;
    }
    console.log(currentUrl);

    const currentUser = await this.userService.getUserInStorage();
    console.log(currentUser);
    if(currentUser) {
      // Vérifie si l’utilisateur fait partie d’un groupe
      const groupes$ = await this.userGroupeService.findBy({ user_id: currentUser.id });
      const groupes = await firstValueFrom(groupes$ as Observable<Groupe[]>);

    // Vérifie si l’utilisateur fait partie d’un organisme
      const organismes$ = await this.userOrganismeService.findBy({ user_id: currentUser.id });
      const organismes = await firstValueFrom(organismes$ as Observable<Organisme[]>);
      
      if ((groupes && groupes.length > 0) || (organismes && organismes.length > 0)) {
        if(this.router.url === '') {
          this.router.navigate(['evenements']);
        }
      } else {
        this.router.navigate(['home']);
      }

      this.authService.checkUserLogged().pipe(take(1)).subscribe(res => {
        if(res !== false){
          this.notificationService.initialiserNotifications();
        }
      })
    }
  }
}
